import { render, staticRenderFns } from "./cockfight-pane.vue?vue&type=template&id=1749f63c&scoped=true"
import script from "./cockfight-pane.vue?vue&type=script&lang=js"
export * from "./cockfight-pane.vue?vue&type=script&lang=js"
import style0 from "./cockfight-pane.vue?vue&type=style&index=0&id=1749f63c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1749f63c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1749f63c')) {
      api.createRecord('1749f63c', component.options)
    } else {
      api.reload('1749f63c', component.options)
    }
    module.hot.accept("./cockfight-pane.vue?vue&type=template&id=1749f63c&scoped=true", function () {
      api.rerender('1749f63c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/desktop/cockfight-pane.vue"
export default component.exports